import React, { useState } from "react";
import { Colors } from "../../../Constants/colors";
import { FontFamily } from "../../../Constants/Enums/FontFamily.enums";
import { ListTableCol } from "./listTableCol";
import { Pagination } from "../../pagination";
import { SkeletonLoader } from "../../loader/skeletonLoader";
import { CheckBox } from "../../input/CheckBox";
import { MoreOptionsMenu } from "../../MoreOptionMenu";
import "./listTable.css";
import { FONT_SIZE } from "../../../Constants/Enums/styles.enum";
import { EmptyList } from "./EmptyList";

interface titles {
  titleName: string;
  colWidth?: string;
  key?: string;
  onClick?: () => unknown;
}
interface PaginationInterface {
  onPageChange: (pageNo: number) => unknown;
  totalPage: number;
}
interface Props {
  titles: Array<titles>;
  data: Array<any>;
  style?: Object;
  isDataLoading?: boolean;
  transformFn: (list: Array<any>) => Array<any>;
  pagination?: PaginationInterface;
  onSelect?: (data: any) => unknown;
  onRowClick?: ((data: any) => unknown) | null;
  moreOptons?: {
    onEdit?: (data: any) => unknown;
    onRemove?: (data: any) => unknown;
  };
}

// TODO -> Give this props a type to make it consistant
export const ListTable = ({
  titles = [],
  data = [],
  isDataLoading = false,
  transformFn,
  pagination,
  onSelect,
  onRowClick = null,
  moreOptons,
}: Props) => {
  const transformDatForTable = transformFn(data || []);
  const [selectedData, setSelectedData] = useState<any | null>(null);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [openMenuIndex, setOpenMenuIndex] = useState<number | null>(null);

  const setSelectedRow = (rowData: any) => {
    if (selectedData && rowData.id === selectedData.id) {
      setSelectedData(null);
    } else {
      setSelectedData(rowData);
    }
  };

  return (
    <div
      style={{
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow:
          "0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)",
        border: `1px solid ${Colors.LightGrey}`,
        background: Colors.White,
      }}
    >
      <div className="container">
        <div
          style={{
            flex: 1,
          }}
        >
          <ListTableCol
            style={{
              backgroundColor: Colors.WhiteSmoke,
              background: `linear-gradient(to bottom, ${Colors.White}, ${Colors.WhiteSmoke})`,
              position: "relative",
              fontWeight: 600,
              fontSize: "13px",
              color: Colors.Black,
              borderBottom: `2px solid ${Colors.LightGrey}`,
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              letterSpacing: "0.6px",
              textTransform: "uppercase" as const,
              fontFamily: FontFamily.POPPINS_BOLD,
              height: "60px",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.03)",
            }}
          >
            {/*   THE WIDTH IS EQUAL TO THE RADIO BUTTON */}

            {onSelect ? <div style={{ width: "13px" }} /> : <></>}

            {titles.map((title, index) => {
              return (
                <div
                  key={index}
                  style={{
                    width: title.colWidth || "80px",
                    fontSize: FONT_SIZE.F12,
                    fontFamily: FontFamily.POPPINS_BOLD,
                    opacity: 0.9,
                  }}
                >
                  {title.titleName}
                </div>
              );
            })}
          </ListTableCol>

          {isDataLoading ? (
            <SkeletonLoader />
          ) : transformDatForTable.length === 0 ? (
            <EmptyList />
          ) : (
            transformDatForTable.map((rowData: any, index: number) => {
              const bgColor =
                index % 2 === 0 ? Colors.White : Colors.VeryLightGrey;

              const isSelected = selectedData && rowData.id === selectedData.id;
              const needsColorChangeOnHover =
                onRowClick && hoveredIndex === index;
              const hoverColor = needsColorChangeOnHover
                ? Colors.WhiteSmoke
                : isSelected
                  ? Colors.LIGHT_TANGERINE_ORANGE
                  : undefined;

              return (
                <div
                  onClick={() => {
                    onRowClick && onRowClick(rowData);
                  }}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  style={{
                    transition: "all 0.2s ease",
                    animation: `fadeInRow 0.3s ease-out ${index * 0.02}s both`,
                  }}
                >
                  <ListTableCol
                    style={{
                      backgroundColor: hoverColor || bgColor,
                      color: needsColorChangeOnHover
                        ? Colors.CrimsonRed
                        : isSelected
                          ? Colors.TangerineOrange
                          : Colors.Black,
                      position: "relative",
                      cursor: onRowClick ? "pointer" : undefined,
                      transition: "all 0.2s ease",
                      borderLeft: needsColorChangeOnHover
                        ? `3px solid ${Colors.CrimsonRed}`
                        : isSelected
                          ? `3px solid ${Colors.TangerineOrange}`
                          : `3px solid transparent`,
                      borderBottom: `1px solid ${
                        needsColorChangeOnHover
                          ? Colors.CrimsonRed + "30"
                          : isSelected
                            ? Colors.TangerineOrange + "40"
                            : Colors.LightGrey
                      }`,
                      transform: needsColorChangeOnHover
                        ? "translateX(2px)"
                        : isSelected
                          ? "translateX(1px)"
                          : "translateX(0)",
                      boxShadow: needsColorChangeOnHover
                        ? `0 2px 8px rgba(158, 7, 7, 0.12)`
                        : isSelected
                          ? `0 1px 4px rgba(254, 168, 1, 0.15)`
                          : "none",
                      fontFamily: FontFamily.ROBOTO_REGULAR,
                      marginBottom: "0",
                      zIndex: needsColorChangeOnHover ? 2 : isSelected ? 1 : 0,
                    }}
                    key={`${index}`}
                  >
                    {onSelect ? (
                      <div>
                        <CheckBox
                          isChecked={rowData.id === (selectedData?.id || "")}
                          setIsChecked={() => {
                            setSelectedRow(rowData);
                            onSelect(rowData);
                          }}
                        />
                      </div>
                    ) : (
                      <></>
                    )}

                    {titles.map((title, titleIndex) => {
                      return (
                        <div
                          key={titleIndex}
                          style={{
                            width: title.colWidth || "80px",
                            overflow: "hidden",
                            whiteSpace: "nowrap" as const,
                            textOverflow: "ellipsis",
                            fontSize: "14px",
                            fontWeight: 500,
                            transition: "color 0.2s ease",
                            fontFamily: FontFamily.ROBOTO_REGULAR,
                          }}
                          onClick={title.onClick}
                        >
                          {rowData[title.key || title.titleName] || ""}
                          {/* For some cases titleName will just be fine as it matches the key name of JSON value */}
                        </div>
                      );
                    })}

                    {!!moreOptons ? (
                      <div
                        style={{
                          position: "absolute",
                          right: 16,
                          transition: "all 0.2s ease",
                          opacity:
                            needsColorChangeOnHover || isSelected ? 1 : 0.6,
                          transform: needsColorChangeOnHover
                            ? "scale(1.05)"
                            : "scale(1)",
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <MoreOptionsMenu
                          isOpen={openMenuIndex === index}
                          onToggle={() => {
                            setOpenMenuIndex(
                              openMenuIndex === index ? null : index,
                            );
                          }}
                          onEdit={
                            moreOptons.onEdit
                              ? () =>
                                  moreOptons.onEdit &&
                                  moreOptons.onEdit(rowData)
                              : undefined
                          }
                          onRemove={
                            moreOptons.onRemove
                              ? () =>
                                  moreOptons.onRemove &&
                                  moreOptons.onRemove(rowData)
                              : undefined
                          }
                        />
                      </div>
                    ) : (
                      <div />
                    )}
                  </ListTableCol>
                </div>
              );
            })
          )}
        </div>
      </div>
      {pagination && Number(pagination.totalPage) > 1 ? (
        <div className="w-full flex justify-center">
          <Pagination
            totalPage={Number(pagination.totalPage)}
            onPageChange={pagination.onPageChange}
          />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
